import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import { Box as BaseBox } from '@/components/Box';
import { NextImage } from '@/components/NextImage';
import type { Maybe } from '@/lib/types';

export const getContentMediaWrapperType = (type: Maybe<string>) => {
  switch (type) {
    case 'LinkCard':
      return css`
        position: relative;
        overflow: hidden;
        height: 168px;
        width: 100%;
        ${({ theme }) => css`
          ${theme.media.md.up} {
            height: 512px;
          }
        `}
      `;
    case 'TopBanner':
      return css`
        position: relative;
        overflow: hidden;
        height: 221px;
        width: 100%;
        position: relative;
        ${({ theme }) => css`
          ${theme.media.md.up} {
            min-height: 320px;
          }
        `}
      `;
    case 'ThreeColumnTeaser':
      return css`
        display: inline-grid;
        overflow: hidden;
        min-height: 206px;
        height: 100%;
        width: 100%;
        position: relative;
        ${({ theme }) => css`
          ${theme.media.sm.up} {
            min-height: 450px;
          }
        `}
      `;
    case 'ThreeColumnStack':
      return css`
        display: inline-grid;
        overflow: hidden;
        min-height: 206px;
        height: 100%;
        width: 100%;
        position: relative;
        ${({ theme }) => css`
          ${theme.media.sm.up} {
            min-height: 450px;
          }
        `}
      `;
    case 'FourColumnScroll':
      return css`
        display: inline-grid;
        overflow: hidden;
        min-height: 206px;
        height: 100%;
        width: 100%;
        position: relative;
        ${({ theme }) => css`
          ${theme.media.sm.up} {
            min-height: 450px;
          }
        `}
      `;
    case 'Auto':
      return css`
        display: block;
        overflow: hidden;
        height: inherit;
      `;
    default:
      return css`
        display: block;
        overflow: hidden;
      `;
  }
};

export const Box = styled(BaseBox)<{ $MediaWrapperType: Maybe<string> }>`
  position: relative;
  height: 100%;
  width: 100%;
  display: block;
  position: relative;

  // TO-DO: we have to use this lines for contentGroups
  /* ${({ $MediaWrapperType }) => css`
    ${getContentMediaWrapperType($MediaWrapperType)}
  `} */
`;

export const Image = styled(NextImage)<{ $MediaWrapperType: Maybe<string> }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImageWrapper = styled.div<{
  $mediaWrapperType: Maybe<string>;
}>`
  position: relative;
  ${({ $mediaWrapperType }) =>
    $mediaWrapperType === 'MediaAndSideText' &&
    css`
      height: 100%;
    `}
`;

export const VideoWrapper = styled.div<{ $videoPlayOption: string }>`
  width: 100%;
`;

export const MobileImageWrapper = styled(Swiper)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      display: none;
    }
  `}
  width: 100%;
`;

export const DesktopImageWrapper = styled.div<{
  $imageLength: number;
  $mediaWrapperType?: string;
}>`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      display: none;
    }
  `}

  & > :nth-child(1) {
    transition: opacity 0.3s ease-in-out;
  }
  & > :nth-child(2) {
    position: absolute;
    top: 0;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  ${({ $imageLength }) =>
    $imageLength > 1 &&
    css`
      &:hover {
        & > :nth-child(1) {
          opacity: 0;
        }
        & > :nth-child(2) {
          opacity: 1;
        }
      }
    `};
  ${({ $mediaWrapperType }) =>
    $mediaWrapperType === 'MediaAndSideText' &&
    css`
      height: 100%;
    `}
`;
